<style lang="scss" src="./Drawer.scss"></style>
<script lang="ts" src="./Drawer.ts"></script>

<template>
  <q-drawer :width="248" v-model="leftDrawerOpen">
    <div class="drawer-vault-logo"></div>
    <Navigation />
  </q-drawer>
</template>
